<div class="page-sub-title">Practice</div>

<div *ngIf="practiceSessionId === null">
    <p>
    <label for="selectedTemplate">Practice Template</label>
    <select
      id="selectedTemplate"
      class="input full-width"
      [(ngModel)]="selectedTemplate"
      name="selectedTemplate"
    >
      <option [ngValue]="null">Select a practice template</option>
      <option *ngFor="let t of templates" [ngValue]="t">
        {{ t.label }}
      </option>
    </select>
  </p>
  <p>
        <button class="btn btn-green btn-full-width margin-top-large" (click)="startPracticeSession()">Start Practicing</button>
    </p>
</div>

<div *ngIf="practiceSessionId !== null && selectedTemplate !== null">
    <div class="card">
        <div class="title">{{ selectedTemplate.label }}</div>
        <p>{{ selectedTemplate.template_drills?.length }} drills</p>
    </div>
    
    <div *ngIf="currentTemplateDrill as d" class="card">
        <div class="title">{{ d.drill?.label }}</div>
        <p>{{ d.drill?.club_label }}</p>
        <p><strong>Shot {{ currentRepNumber }} of {{ d.number_of_reps }}</strong></p>

        <div class="margin-top-large">
            <button class="btn-small btn-full-width" *ngFor="let r of sortedResultOptions" (click)="selectResult(r)">{{ r.label }}</button>
        </div>

        <div class="margin-top-large">
            <button class="btn" (click)="moveToPreviousRep()" [disabled]="isFirstDrill && isFirstRep">Previous Shot</button>
            <button class="btn btn-green" (click)="moveToNextRep()" [disabled]="isLastDrill && isLastRep">Next Shot</button>
        </div>          
    </div>
    <div class="margin-top-large">
        <button class="btn" (click)="moveToPreviousDrill()" [disabled]="isFirstDrill">Previous Drill</button>
        <button class="btn btn-green" (click)="moveToNextDrill()" [disabled]="isLastDrill">Next Drill</button>
    </div>
</div>